import store from '../store';

export const definirNbs = (nbs) => {
    if (!nbs) {
        return [];
    }
    else if (nbs === "erro") { // nbs veio "erro": so salva se for a 1a vez
        let usuarioNbs = store.getState().session.usuario.nb;
        return usuarioNbs ? usuarioNbs : nbs;
    } else { // nbs voltaram
        return (Array.isArray(nbs)) ? nbs : [nbs];
    }
};

export const definirPessoa = (pessoa) => {
    if (!pessoa || typeof pessoa !== "string") return pessoa;

    const pessoaErroArray = ["erro", "not found", "obito", ""];
    if (pessoaErroArray.includes(pessoa)) {
        let pessoaCnis = store.getState().session.pessoaCnis;
        return pessoaCnis ?? pessoa;
    }

    try {
        return JSON.parse(pessoa);
    } catch (e) {
        return pessoa; // ou null
    }
};


export const isPessoaValida = (pessoaStr) => {
    const pessoaErroArray = ["erro", "not found", "obito", ""];
    if (!pessoaStr || pessoaErroArray.includes(pessoaStr)) return false;

    const pessoa = definirPessoa(pessoaStr);
    const hasMessageError = pessoa && typeof pessoa === 'object' &&
      Object.prototype.hasOwnProperty.call(pessoa, "mensagens");

    return !hasMessageError;
};